import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

// Redux actions
import { getResearchPage } from "../../../redux/slices/ServicePagesSlice";

// Components
import PageBanner from "../../components/layout/pages/PageBanner";
import AssignmentWriters from "../../components/layout/pages/AssignmentWriters";
import Help from "../../components/layout/pages/Help";
import HelpFeatures from "../../components/layout/pages/HelpFeatures";
import FAQ2 from "../../components/layout/pages/FAQ2";

const ResearchProposalWriting = () => {
  const dispatch = useAppDispatch();

  // Redux stores
  const { researchPageStatus, researchPageData } = useAppSelector(
    (state) => state.servicePages
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    if (researchPageStatus !== "success") {
      dispatch(getResearchPage());
    }
  }, []);

  return (
    <>
      {/* page banner area start */}
      <PageBanner
        className="about-inner-banner"
        title={researchPageData.sec_1_i_banner[0].heading}
        description={researchPageData.sec_1_i_banner[0].subheading}
        reviewSites={researchPageData.sec_1_i_banner[0].inner_banner_review}
      />
      {/* page banner area end */}

      {/* wrapper area start */}
      <div className="wrapper">
        {/* Assignment Writers */}
        <section className="assignment-writers-area">
          <div className="container">
            <AssignmentWriters
              title1="Meet Our Professional Paper Writers"
              title2="Book qualified writers to guarantee an A+ in MBA papers."
              data={researchPageData.sec_main.sec_2_assignment_writer}
            />
          </div>
        </section>

        {/* Get Help */}
        <Help
          headingOneText={researchPageData.sec_main.sec_3_h1}
          headingTwoText={researchPageData.sec_main.sec_3_h2}
          data={researchPageData.sec_main.sec_3_it_1}
        />

        {/* help features */}
        <HelpFeatures
          headingOneText={researchPageData.sec_main.sec_4_h1}
          headingTwoText={researchPageData.sec_main.sec_4_h2}
          data={researchPageData.sec_main.sec_4_it_1}
          helpButton={false}
        />

        {/* faq area 2 */}
        <FAQ2 dataType="write_my_paper" data={researchPageData.sec_main.sec_5_at} />
      </div>
      {/* wrapper area end */}
    </>
  );
};

export default ResearchProposalWriting;
